import { useRequiredParams } from '@pba/react-router';
import { OrganizationDetail, OrganizationDetailHeader, OrganizationLayout } from 'features/organizations';
import { useGetPathToEntityDetail } from '../../hooks';
import { useNavigateToOrganizationEntity } from '../hooks';

const PageOrganizationDetail = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigateToOrganizationEntity = useNavigateToOrganizationEntity();

  return (
    <OrganizationLayout
      header={(organization) => <OrganizationDetailHeader organization={organization} />}
      organizationId={organizationId}
    >
      {(organization) => (
        <OrganizationDetail
          getPathToEntityDetail={getPathToEntityDetail}
          navigateToOrganizationEntity={navigateToOrganizationEntity}
          organization={organization}
        />
      )}
    </OrganizationLayout>
  );
};

export default PageOrganizationDetail;
